import type { SVGProps } from 'react';

const SvgBjNoticeOnLt = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M4.37972 8.25073C3.61878 8.25073 3 8.76426 3 9.39013V19.1552C3 20.1743 4.00343 21.0007 5.23263 21.0007H12.75'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M19.6203 8.25073C20.3812 8.25073 21 8.76426 21 9.39013V19.1552C21 20.1743 19.9966 21.0007 18.7674 21.0007H11.25'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M3.75 9.01058L10.4229 16.4884C11.3343 17.513 12.8321 17.5032 13.7356 16.4687L20.25 9.00073'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M4.5 9.75073V5.6697C4.5 4.19556 5.44093 3.00073 6.59357 3.00073H17.4064C18.5669 3.00073 19.5 4.19556 19.5 5.6697V9.75073'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M8.25 6.75073H15.75' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M9.75 9.75073H14.25' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
    <circle cx={22} cy={2} r={2} fill='#FF5A5A' />
  </svg>
);
export default SvgBjNoticeOnLt;
